import { render } from "./AdminTipuri.vue?vue&type=template&id=4a9e87c5&scoped=true&ts=true"
import script from "./AdminTipuri.ts?vue&type=script&lang=ts"
export * from "./AdminTipuri.ts?vue&type=script&lang=ts"

import "./AdminTipuri.vue?vue&type=style&index=0&id=4a9e87c5&scoped=true&lang=scss"

import exportComponent from "D:\\ColorMetalRO\\cmportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9e87c5"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTree from 'quasar/src/components/tree/QTree.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QUploader from 'quasar/src/components/uploader/QUploader.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QUploaderAddTrigger from 'quasar/src/components/uploader/QUploaderAddTrigger.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn,QInput,QTree,QTooltip,QDialog,QCard,QBar,QCardSection,QScrollArea,QForm,QUploader,QSpinner,QUploaderAddTrigger,QImg,QSpinnerGears});qInstall(script, 'directives', {ClosePopup});
